var render = function render(){var _vm=this,_c=_vm._self._c;return (
      _vm.$store.state.toLastKeyName == '对话中' ||
      _vm.$store.state.toLastKeyName == '疑似骚扰用户' ||
      _vm.$store.state.toLastKeyName == '浏览中'
    )?_c('div',{staticClass:"tools_div"},[_c('el-switch',{staticStyle:{"margin-left":"10px"},attrs:{"active-text":"机器人托管","inactive-text":"取消托管"},on:{"change":_vm.switchChange},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}}),_c('el-button',{staticClass:"sendBtn",attrs:{"type":"primary","size":"mini","disabled":_vm.config.canOperate == false},on:{"click":_vm.sendAction}},[_vm._v("发送")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }